import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  getOperationDataInit,
  getOperationDataSuccess,
  fetchFilteredTableDataFailure,
  fetchFilteredTableDataSuccess,
  fetchFilteredTableDataInit,
  getOperationDataFailure,
  setLoading,
  getOperationFilteredDataInit,
  getOperationFilteredDataFailure,
  getOperationFilteredDataSuccess,
  getDetailsPageDataInit,
  getDetailsPageDataFailure,
  getDetailsPageDataSuccess,
  setSearchFields,
  fetchWorkScreenData,
  postWorkScreenData,
  getWorkScreenDataSuccess,
  getWorkScreenDataFailure,
  setIsWorkScreenLoading,
  getMemberId,
  postWorkScreenDataSuccess,
  setRequestStart,
} from "../slices/operationHomeSlice";
import { getOperationData as getOperationDataApi } from "../../operations/services/getOperationDataRequest";
import getFilteredDataAPI from "../../operations/services/getFilteredData";
import { fetchFilteredTableData } from "../../operations/services/paginationRequest";
import getDetailsPageDataAPI from "../../operations/services/getDetailsPageDataAPI";
import workScreenData from "../../operations/services/dummyApi";
import { getRequest } from "../../operations/services/getRequest";
import { postRequest } from "../../operations/services/postRequest";
import { useSelector } from "react-redux";
import {
  getWorkScreenDataAPI,
  postWorkScreenDataAPI,
} from "../../operations/services/getWorkScreenDataAPI";

import {
  fetchPerformanceDataInit,
  fetchPerformanceDataSuccess,
  fetchPerformanceDataFailure,
} from "../slices/operationHomeSlice";
import { notify } from "../../common/Helper/notification";
// import { AgentDummyData } from '../../operations/pages/AgentHome/AgentDummyjson';
import { AgentDummyData } from "../../agent/pages/AgentHome/AgentDummyjson";

function* getOperationData(action) {
  try {
    yield put(setLoading(true));
    yield put(setSearchFields({}));
    const value = action.payload;
    // console.log(value);
    const data = yield call(getOperationDataApi, value);
    yield put(getOperationDataSuccess(data));
  } catch (error) {
    yield put(getOperationDataFailure(error.message));
  }
}

// function* getOperationHomeData(action) {
//   try {
//     yield put (setLoading (true))
//     const value = action.payload
//     const data = yield call(getOperationDataApi, value)
//     yield put(homeInitSuccess(data))
//   } catch (error) {
//     yield put (homeInitFailure(error.message))
//   }
// }

const NO_RESULTS_TOAST_ID = "operation-home-no-results";

function* getOperationFilteredData(action) {
  try {
    yield put(setLoading(true));
    // Use allSearches (includes client-side quality filter) when provided so
    // the Quality Score tag is preserved in Redux and the active-filters UI.
    const fieldsToStore = action.payload.allSearches
      ? { searches: action.payload.allSearches, page: action.payload.body.page }
      : action.payload.body;
    yield put(setSearchFields(fieldsToStore));

    const data = yield call(
      getFilteredDataAPI,
      action.payload.body,
      action.payload.params
    );

    yield put(getOperationFilteredDataSuccess(data));

    if (!data.data || data.data.length === 0) {
      // Fixed toastId: react-toastify ignores a new toast() call while one
      // with the same id is already on screen, so typing letter-by-letter
      // through several no-match searches no longer stacks up toasts.
      notify.info("No records match the selected criteria.", null, {
        toastId: NO_RESULTS_TOAST_ID,
      });
    } else {
      notify.dismiss(NO_RESULTS_TOAST_ID);
    }
  } catch (error) {
    yield put(getOperationFilteredDataFailure(error.message));
  }
}

function* fetchFilteredData(action) {
  try {
    const {
      pageSize,
      currentPage,
      activeTab,
      startDate,
      endDate,
      searchFields,
    } = action.payload;

    // console.log("🟡 SORT REQUEST PAYLOAD:", action.payload);
    // console.log("🟡 SORT FIELD:", searchFields?.sort);
    // console.log("🟡 SORT ORDER:", searchFields?.sortType);

    yield put(setLoading(true));

    const data = yield call(
      fetchFilteredTableData,
      pageSize,
      currentPage,
      activeTab,
      startDate,
      endDate,
      searchFields
    );
console.log("API DEBUG:", {
  totalCalls: data?.totalCalls,
  totalRows: data?.total_rows,
  dataLength: data?.data?.length
});
    // console.log("🟢 API RESPONSE:", data);

    if (data?.data) {
      console.table(
        data.data.map((row) => ({
          member: row.memberName,
          feedback: row.FeedbackStatus,
        }))
      );
    }

    yield put(
      fetchFilteredTableDataSuccess({
        tableData: data.data,
        totalDataCount: data.total_rows,
        currentPage: data.current_page,
        pageSize: data.page_limit,
        closed: data?.closed,
        open: data?.open,
        inProgress: data?.inProgress,
        VMopen: data?.VMopen,
        VMinProgress: data?.VMinProgress,
        VMclosed: data?.VMclosed,
        duration: {
          hours: data?.duration?.hours,
          minutes: data?.duration?.minutes,
          seconds: data?.duration?.seconds,
        },
       totalCalls: data?.totalCalls,
      })
    );

  } catch (error) {
    console.error("🔴 FETCH FILTERED DATA ERROR:", error);
    yield put(fetchFilteredTableDataFailure(error.message));
  }
}
function* getDetailsPageData(action) {
  try {
    const memberId = action.payload;
    yield put(setLoading(true));

    const data = yield call(getDetailsPageDataAPI, memberId);
    console.log("details", data);
    yield put(getDetailsPageDataSuccess(data));
  } catch (error) {
    yield put(getDetailsPageDataFailure(error.message));
  }
}

// function*  workGetWorkScreenData(action) {
//   try {
//     const callId = action.payload;
//     let url= `https://contact-center-plus.azurewebsites.net/api/issue-details?code=P12ljRPqzxIzeNASuW7l5AyRYESY4JJbORwzwU8Oe4GjAzFuTguj0A%3D%3D&customerId=${callId}`
//     let data =yield getRequest(url);
//     console.log(callId.charCodeAt());
//     console.log(callId);
//     put(setIsWorkScreenLoading(true));
//     // const data = workScreenData[1];
//     yield put(getWorkScreenDataSuccess(data.data));
//   } catch (error) {
//     yield put(getWorkScreenDataFailure(error.message));
//   }
// }
// function* workPostWorkScreenData(payload,memberId){
//   try{
//     // const callId = action.payload;
//     let url= `https://contact-center-plus.azurewebsites.net/api/issue-details?code=P12ljRPqzxIzeNASuW7l5AyRYESY4JJbORwzwU8Oe4GjAzFuTguj0A%3D%3D&customerId=${payload.payload.customerId}`
//       console.log(payload.payload,memberId);
//       let response =yield postRequest(url,payload.payload);
//       yield workGetWorkScreenData();
//       console.log(response);
//   }catch(error){

//   }
// }

function* workGetWorkScreenData(action) {
  try {
    const { memberId, callId } = action.payload;
    console.log("myCallId:", callId, "myMemberId:", memberId);

    const data = yield call(getWorkScreenDataAPI, callId, memberId);
    console.log("hello", data);

    yield put(getWorkScreenDataSuccess(data));
  } catch (error) {
    yield put(getWorkScreenDataFailure(error.message));
  }
}

function* workPostWorkScreenData(action) {
  try {
    const payload = action.payload;
    console.log("mycallId", payload);
    yield put(setIsWorkScreenLoading(true));
    yield put(setRequestStart());
    yield call(postWorkScreenDataAPI, payload);
    const callId = payload.callId || null;
    yield workGetWorkScreenData({
      payload: { memberId: payload.customerId, callId },
    });
    yield put(postWorkScreenDataSuccess());
  } catch (error) {
    yield put(getWorkScreenDataFailure(error.message));
  }
}

// function* getPerformanceData(action) {
//   try {
//     yield put(fetchPerformanceDataSuccess(AgentDummyData[action.payload]));

//   } catch (error) {
//     console.log(" wrong data will fetch ");
//   }
// }

export function* watchOperationData() {
  yield takeLatest(getOperationDataInit.type, getOperationData);
  yield takeLatest(fetchFilteredTableDataInit.type, fetchFilteredData);
  // yield takeLatest(homeInit.type, getOperationHomeData)
  yield takeLatest(getOperationFilteredDataInit.type, getOperationFilteredData);
  yield takeLatest(getDetailsPageDataInit.type, getDetailsPageData);
  yield takeLatest(fetchWorkScreenData.type, workGetWorkScreenData);
  yield takeLatest(postWorkScreenData.type, workPostWorkScreenData);
  // yield takeLatest(fetchPerformanceDataInit.type, getPerformanceData);
}
